import React from 'react';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import { Typography } from '@material-ui/core';
import toIndianCurrency from 'utils/ToIndianCurrencyFormat.js';
import MoreTruckerDeductions from './MoreTruckerDeductions';

const greyRowWithoutCheckbox = {
  background: '#D3D3D3',
  display: 'flex',
  alignItems: 'center',
  padding: '5px 20px',
  borderRadius: '5px',
  justifyContent: 'space-between',
  marginBottom: '10px',
};

const orangeRowWithoutcheckbox = {
  background: '#FFD8B3',
  display: 'flex',
  alignItems: 'center',
  padding: '5px 20px',
  borderRadius: '5px',
  justifyContent: 'space-between',
  marginBottom: '10px',
};

const TripDeductionFields = ({ classes, indentDetails, state }) => {
  return (
    <GridContainer direction="row" spacing={1}>
      <GridItem xs={12} sm={12} md={12}>
        <GridContainer className={classes.customMargin}>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            className={classes.noPadding}
            style={{
              float: 'left',
              textAlign: 'left',
              paddingLeft: '0px !important',
            }}
          >
            <h3
              style={{
                fontSize: '16px',
                color: 'black',
                fontWeight: '400',
                margin: '10px 0px',
              }}
            >
              Transporter Deductions
            </h3>
          </GridItem>
          <GridItem className={classes.noPadding} xs={12} sm={12} md={12}>
            <GridContainer spacing={2}>
              <GridItem xs={6} md={4}>
                <div style={greyRowWithoutCheckbox}>
                  <Typography variant="body1">CHALLAN</Typography>
                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    {toIndianCurrency(
                      indentDetails?.challan_transporter_amount
                    )}
                  </Typography>
                </div>
              </GridItem>
              <GridItem xs={6} md={4}>
                <div style={greyRowWithoutCheckbox}>
                  <Typography variant="body1">PENALTY</Typography>
                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    {toIndianCurrency(
                      indentDetails?.penalty_transporter_amount
                    )}
                  </Typography>
                </div>
              </GridItem>
              <GridItem xs={6} md={4}>
                <div style={greyRowWithoutCheckbox}>
                  <Typography variant="body1">TDS</Typography>
                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    {toIndianCurrency(indentDetails?.tds_transporter_amount)}
                  </Typography>
                </div>
              </GridItem>
              <GridItem xs={6} md={4}>
                <div style={greyRowWithoutCheckbox}>
                  <Typography variant="body1">DOC CHARGES</Typography>
                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    {toIndianCurrency(
                      indentDetails?.doc_charges_transporter_amount
                    )}
                  </Typography>
                </div>
              </GridItem>
              <GridItem xs={6} md={4}>
                <div style={greyRowWithoutCheckbox}>
                  <Typography variant="body1">FUEL CHARGES</Typography>
                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    {toIndianCurrency(
                      indentDetails?.fuel_charges_transporter_amount
                    )}
                  </Typography>
                </div>
              </GridItem>
              <GridItem xs={6} md={4}>
                <div style={greyRowWithoutCheckbox}>
                  <Typography variant="body1">MAAMOL CHARGES</Typography>
                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    {toIndianCurrency(
                      indentDetails?.maamol_charges_transporter_amount
                    )}
                  </Typography>
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <GridContainer className={classes.customMargin}>
          <GridItem
            xs={12}
            sm={12}
            md={12}
            className={classes.noPadding}
            style={{
              float: 'left',
              textAlign: 'left',
              paddingLeft: '0px !important',
            }}
          >
            <h3
              style={{
                fontSize: '16px',
                color: 'black',
                fontWeight: '400',
                margin: '10px 0px',
              }}
            >
              Trucker Deductions
            </h3>
          </GridItem>
          <GridItem className={classes.noPadding} xs={12} sm={12} md={12}>
            <GridContainer spacing={2}>
              <GridItem xs={6} md={4}>
                <div style={orangeRowWithoutcheckbox}>
                  <Typography variant="body1">CHALLAN</Typography>
                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    {toIndianCurrency(indentDetails?.challan_trucker_amount)}
                  </Typography>
                </div>
              </GridItem>
              <GridItem xs={6} md={4}>
                <div style={orangeRowWithoutcheckbox}>
                  <Typography variant="body1">PENALTY</Typography>
                  <Typography
                    variant="body1"
                    style={{
                      color: 'black',
                    }}
                  >
                    {toIndianCurrency(indentDetails?.penalty_trucker_amount)}
                  </Typography>
                </div>
              </GridItem>
            </GridContainer>
          </GridItem>
        </GridContainer>
      </GridItem>

      <MoreTruckerDeductions
        state={state}
        classes={classes}
        indentDetails={indentDetails}
      />
    </GridContainer>
  );
};

export default TripDeductionFields;
